<template>
  <div id="Gmap">
    <h1>Callogs</h1>
    <v-btn class="ma-2" :href="'https://www.google.com/maps/@' + latitude+','+longitude+',17z'" target="_blank" outlined color="teal" @click="tabeRe()">
      <v-icon>mdi-google-maps</v-icon>Get current location
    </v-btn>
  </div>
</template>
<style scoped>
</style>
<script>
import { locationList } from "../../firebaseConfig";
export default {
  name: "Gmap",
  data() {
    return {
      search: "",
       myitems: [],
       latitude:"",
       longitude:"",

    };
  },
  mounted: function () {
    this.myD();
  },
  methods: {
    async myD() {
        
     return locationList.child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1").child("868068040704056").on("value", snapshot => {
        this.latitude = snapshot.val().latitude;
        this.longitude = snapshot.val().longitude;
        
        console.log( this.myitems);  
        console.log(this.latitude) ;
        console.log(this.longitude) ;
        
      }

      );

    },

  }
};
</script>